module.exports = __webpack_public_path__ + "img/20190924153714242.18e30628.jpg";